import { TinyEmitter } from 'tiny-emitter';
import pvTrackService from '../pvtrack.service';
/**
 * 计算一组点位中心点
 * @param {*} pointes
 * @returns
 */
function calculateCenterPointer(pointes) {
  const initPoint = new window.THREE.Vector3(0, 0, 0);
  initPoint.y = -1; //pointes[0].y;
  pointes.forEach((element) => {
    initPoint.x += element.x;
    initPoint.z += element.z;
  });
  const total = pointes.length;
  initPoint.x = initPoint.x / total;
  initPoint.z = initPoint.z / total;
  // console.log('initPoint', pointes, initPoint);
  return initPoint;
}
/**
 * 获取相机观察的位置点
 * @param {*} quaternion
 * @returns
 */
function getLookAtPoint(quaternion) {
  const lookAtPoint = new window.THREE.Vector3(0, 0, -1).applyQuaternion(
    quaternion,
  );
  //.add(player.cameraControls.activeControl.camera.position);
  return lookAtPoint;
}
/**
 * 获取两个位置点最近的旋转方向
 * https://zhuanlan.zhihu.com/p/359975221
 * https://zhuanlan.zhihu.com/p/194191652
 * https://qa.1r1g.com/sf/ask/1036973171/
 * https://gameinstitute.qq.com/community/detail/112157
 * @param {*} vector1 开始位置
 * @param {*} vector2 结束位置
 * @returns
 */
function getDirection(vector1, vector2) {
  // 获取两个位置点最近的旋转方向
  return new window.THREE.Vector3().crossVectors(vector1, vector2).y;
}
/**
 * 需求： http://wiki.corpautohome.com/pages/viewpage.action?pageId=239908128
 */
export class RotateCar extends TinyEmitter {
  constructor(player, panoIds = []) {
    super();
    this.player = player;
    this.bindEvents();
    this.panoIds = panoIds;
    const pointes = player.$app.Scene.panos.list
      .filter((o) => panoIds.includes(o.id))
      .map((o) => o.position);
    const centerPoint = calculateCenterPointer(pointes);
    this.centerPoint = centerPoint;
  }
  getNextPanoId(direction, currentPanoId) {
    let index = this.panoIds.indexOf(currentPanoId);
    if (direction === 'left') {
      index = index - 1;
    } else {
      index = index + 1;
    }
    if (index === -1) {
      index = this.panoIds.length - 1;
    } else if (index === this.panoIds.length) {
      index = 0;
    }
    return {
      panoId: this.panoIds[index],
    };
  }
  bindEvents() {
    const self = this;
    const player = this.player;

    const carDirection = CarDirectionFactory.getCarDirection('touch', player);
    carDirection.on('moved', function ({ direction }) {
      const currentPanoId = player.$app.Scene.panoId;
      if (self.panoIds.includes(currentPanoId)) {
        const info = self.getNextPanoId(direction, currentPanoId);
        self.emit('car.rotated', {
          direction,
          ...info,
          centerPoint: self.centerPoint,
        });
      }
    });
    self.carDirection = carDirection;
  }
}
let CarDirection = {};
const CarDirectionFactory = {
  getCarDirection(mode, player) {
    if (CarDirection[mode]) {
      return CarDirection[mode];
    }
    switch (mode) {
      case 'touch':
        CarDirection[mode] = new TouchDirection(player);
        return CarDirection[mode];
      case 'rotation':
      default:
        CarDirection[mode] = new RotationDirection(player);
        return CarDirection[mode];
    }
  },
};

class Direction extends TinyEmitter {
  constructor(gap) {
    super();
    this.gap = gap;
    this.startTime = 0;
    this.rotatedCarMode = false;
  }
  isLongTap() {
    if (this.rotatedCarMode) {
      return true;
    }
    if (!this.rotatedCarMode && this.startTime) {
      const now = new Date().getTime();
      if (now - this.startTime > this.gap) {
        // 长按
        console.log('符合长按');
        this.rotatedCarMode = true;
        return true;
      } else {
        this.startTime = 0;
      }
    }
    return false;
  }
  reset() {
    this.startTime = 0;
    this.rotatedCarMode = false;
  }
  showTips() {
    console.log('showTips');
  }
  hideTips() {
    console.log('hideTips');
  }
  show() {
    console.log('show');
  }
  hide() {
    console.log('hide');
  }
}
/**
 * 根据触摸事件计算旋转方向
 */
class TouchDirection extends Direction {
  constructor() {
    super(30);
    this.element = document.getElementById('dealer-slider');
    this.initEvents();
  }
  initEvents() {
    let self = this;
    let startPos = 0;
    let lastPost = 0;
    this.element.addEventListener(
      'touchstart',
      function (e) {
        startPos = e.touches[0].clientX;
        lastPost = startPos;
        self.startTime = new Date().getTime();
      },
      true,
    );
    this.element.addEventListener(
      'touchmove',
      function (e) {
        let currentPos = e.touches[0].clientX;
        if (self.isLongTap()) {
          let direction = 'none';
          if (currentPos - lastPost > 0) {
            direction = 'left';
          } else {
            direction = 'right';
          }
          console.log('direction', direction);
          self.emit('moved', { direction });
        }
        lastPost = currentPos;
        e.preventDefault();
      },
      { passive: false },
    );
    this.element.addEventListener(
      'touchend',
      function () {
        startPos = 0;
        lastPost = 0;
        pvTrackService.pvTrackLogger({ action: 'ZNZT_2023chick_02' });
        self.reset();
      },
      false,
    );
  }
  hideTips() {
    let children = this.element.children[0].children;
    for (let i = 0; i < children.length; i++) {
      if (children[i].classList.contains('dlrSlideTips-text')) {
        continue;
      }
      children[i].style.display = 'none';
    }
  }
  show() {
    this.element.style.display = '';
    // 检查本次是否已经展示过， 未展示过展示tips， 5s内隐藏tips
    setTimeout(() => {
      this.hideTips();
    }, 5000);
  }
  hide() {
    this.element.style.display = 'none';
  }
}
/**
 * 根据相机所看点位计算旋转方向
 */
class RotationDirection extends Direction {
  constructor(player) {
    super(30);
    this.player = player;
    this.initEvents();
  }
  initEvents() {
    let self = this;
    let startLookedPoint = null;
    let lastLookedPoint = null;
    const player = self.player;
    player.on('input.start', function () {
      const quaternion = self.player.camera.quaternion.clone();
      startLookedPoint = getLookAtPoint(quaternion);
      lastLookedPoint = startLookedPoint;
      self.startTime = new Date().getTime();
    });

    player.on('rotate', ({ quaternion }) => {
      const currentPoint = getLookAtPoint(quaternion.clone());
      if (self.isLongTap()) {
        let direction = getDirection(lastLookedPoint, currentPoint);
        if (Math.abs(direction) > 0.01) {
          const directionName = direction > 0 ? 'left' : 'right';
          console.log('direction', direction, directionName);
          self.emit('moved', { direction: directionName });
        }
      }
      lastLookedPoint = currentPoint;
    });
    player.on('endRotation', function () {
      startLookedPoint = null;
      lastLookedPoint = null;
      self.reset();
    });
  }
}
